import React, { useState, memo } from 'react';
import { Heart, MessageCircle, Gift, Lock, Star, Crown, Trophy, Clock, Play, Zap, Image, Send, Bookmark, MapPin, Share2, MoreHorizontal, Check } from 'lucide-react';
import { YogaPost } from './YogaPost';
import { CustomerProfile } from './CustomerProfile';
export const SocialLifeSection = () => {
  const [activeTab, setActiveTab] = useState('myAI');
  const [showComments, setShowComments] = useState(false);
  const [savedPost, setSavedPost] = useState(false);
  // Render CustomerProfile component with full width
  return <div className="w-full" data-id="element-19938">
      <CustomerProfile data-id="element-19939" />
    </div>;
};